{
  "header": {
    "nameShowStaticText": true,
    "nameStaticText": "Used Model: OPC 40084-11",
    "modelShowStaticText": false,
    "modelVariable": {
      "id": "775cf52d-dec9-40bb-b718-0c90c83a5a73",
      "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/Extrusion_v2/GeneralTypes/",
      "nodeId": "ns=1;i=6661",
      "displayName": "Model",
      "variablePath": "Identification.Model",
      "dataType": "LocalizedText",
      "valueRank": -1,
      "modellingRule": "Mandatory",
      "hasProperties": false
    }
  },
  "imagesConfig": {
    "imageDefaults": {
      "[\\s\\S]*": "pr_opc40084-11.jpg"
    }
  },
  "timeline": {
    "variable": {
      "id": "04c23279-14cf-4a9e-80f0-88d69449d779",
      "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/Extrusion_v2/GeneralTypes/",
      "nodeId": "ns=1;i=6682",
      "displayName": "CurrentState",
      "variablePath": "MachineryBuildingBlocks.MachineryItemState.CurrentState",
      "dataType": "LocalizedText",
      "valueRank": -1,
      "modellingRule": "Mandatory",
      "hasProperties": true
    },
    "colorValues": {
      "Executing": "#00ff00",
      "NotAvailable": "#c8c8c8",
      "OutOfService": "#ff0000",
      "NotExecuting": "#ffff00"
    }
  },
  "sections": [
    {
      "isPlaceholder": false,
      "title": "Identification",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Machine Type",
              "showAsLink": false,
              "valueVariable": {
                "id": "25287a3f-d266-4aea-8b3a-5ba3217ada5d",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/Extrusion_v2/GeneralTypes/",
                "nodeId": "ns=1;i=6656",
                "displayName": "DeviceClass",
                "variablePath": "Identification.DeviceClass",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer",
              "showAsLink": false,
              "valueVariable": {
                "id": "7f3e343f-619a-4fba-9e08-146666bd12cb",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/Extrusion_v2/GeneralTypes/",
                "nodeId": "ns=1;i=6652",
                "displayName": "Manufacturer",
                "variablePath": "Identification.Manufacturer",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Model",
              "showAsLink": false,
              "valueVariable": {
                "id": "775cf52d-dec9-40bb-b718-0c90c83a5a73",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/Extrusion_v2/GeneralTypes/",
                "nodeId": "ns=1;i=6661",
                "displayName": "Model",
                "variablePath": "Identification.Model",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Serial Number",
              "showAsLink": false,
              "valueVariable": {
                "id": "e332a619-dbc8-4752-898e-4ddbc844ee17",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/Extrusion_v2/GeneralTypes/",
                "nodeId": "ns=1;i=6653",
                "displayName": "SerialNumber",
                "variablePath": "Identification.SerialNumber",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            }
          ]
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Monitoring",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "In Production Position",
              "showAsLink": false,
              "valueVariable": {
                "id": "2399dd35-e2f3-4349-93bb-015d9994d4c6",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/Extrusion_v2/HaulOff/",
                "nodeId": "ns=1;i=6013",
                "displayName": "ClampClosed",
                "variablePath": "ClampClosed",
                "dataType": "Boolean",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Extruder Enabled",
              "showAsLink": false,
              "valueVariable": {
                "id": "e8d2f9cb-b3a0-4aaa-aadc-528ebf5aa9ae",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/Extrusion_v2/Corrugator/",
                "nodeId": "ns=1;i=6002",
                "displayName": "ExtruderEnabled",
                "variablePath": "ExtruderEnabled",
                "dataType": "Boolean",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            }
          ]
        },
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 1,
              "isPlaceholder": true,
              "placeholderObject": "Drives.<Name>_<Nr>.[PLACEHOLDER]",
              "labelVariable": {
                "id": "f85efe5a-ca0a-48db-bb58-b0db409e6e5f",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/Extrusion_v2/GeneralTypes/",
                "nodeId": "ns=1;i=6110",
                "displayName": "Position",
                "variablePath": "Position",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              },
              "valueVariable": {
                "id": "82d1f64f-b39d-46b5-a326-3ed89896d220",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/GeneralTypes/",
                "nodeId": "ns=1;i=6568",
                "displayName": "ActualValue",
                "variablePath": "Speed.ActualValue",
                "dataType": "Double",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": true
              }
            },
            {
              "type": 1,
              "isPlaceholder": true,
              "placeholderObject": "TemperatureZones.TemperatureZone_<Nr>.[PLACEHOLDER]",
              "labelVariable": {
                "id": "f85efe5a-ca0a-48db-bb58-b0db409e6e5f",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/Extrusion_v2/GeneralTypes/",
                "nodeId": "ns=1;i=6110",
                "displayName": "Id",
                "variablePath": "Id",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              },
              "valueVariable": {
                "id": "344f94e4-861f-40eb-92a9-3499aebc4783",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/Extrusion_v2/GeneralTypes/",
                "nodeId": "ns=1;i=6115",
                "displayName": "ActualValue",
                "variablePath": "ActualValue",
                "dataType": "Double",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": true
              }
            }
          ]
        }
      ]
    }
  ]
}
